// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__YzzQu","content":"MainLayout_content__dmYK2"};